module.exports = "/_next/static/images/58af80dac2bcbe1796ff3aed8e97699d-medium-nyt.png.webp";